import React from 'react';
import loadable from '@loadable/component';
import type { Props } from './content';

const SidebarMobileContentLoadable = loadable(
  () => import(/* webpackChunkName: "sidebar-mobile" */ './content')
);

const SidebarMobileContent = (props: Props) => (
  <SidebarMobileContentLoadable {...props} />
);

export default SidebarMobileContent;
